import { ProductCatalog } from "./Catalog";
import { CouponType } from "./Coupon";
import { DownDeposit, Experience } from "./Experience";
import { Form } from "./Form";
import { Media } from "./Media";
import { PaymentMethod } from "./Payment";
import { Product } from "./Product";
import { PurchaseRule } from "./PurchaseRule";
import { Schedule } from "./Schedule";
import { Term } from "./Term";

export interface SelectedProduct { product: { id: ID } | Experience; sequence: number; }

export interface Package extends Product {
    name: string;
    excerpt: string;
    desc: string;
    purchaseRule: PurchaseRule;
    minimumTransitDuration: number; // Duration between events
    cancellation?: {
        policy: string;
        refundable: boolean;
    };
    seller: {
        id: ID;
    };
    catalog: ProductCatalog;
    other?: string;
    cancellationPolicy?: null;
    paymentMethod?: PaymentMethod;
    terms?: Term;
    photo?: Media;
    medias: Media[];
    downDeposit?: DownDeposit;
    form: Form;
    selectedProducts: SelectedProduct[];
    schedules?: Schedule[];
    type?: PackageType;
    allowedCouponTypes?: CouponType[];
}

export enum PackageType {
    DEMOGRAPHICS_SHARED = "demographics_shared",
    DEMOGRAPHICS_VARIES = "demographics_varies",
}

export enum PackageSequences {
    SELECTED_PRODUCTS_SEQUENCE_START = 1000,
}
